export default __webpack_public_path__ + "829f14e0d7bd5149f8d3fbcd92f53ddd.svg";